import { AuthResource, authResource } from '@witkac/kartamiejska-resources';

import { AbstractModule } from './abstract.module';

/**
 * Moduł sprawdzania dostępu
 *
 * @export
 * @class AccessModule
 * @extends {AbstractModule<AuthResource>}
 */
export class AccessModule extends AbstractModule<AuthResource> {
  public state = {
    checked: {}
  };

  public actions = {
    // Sprawdza, czy użytkownik posiada dane uprawnienia
    check: (context: any, permissions: string[]) => {
      const toCheck = permissions.filter(permission => context.state[permission] === undefined);
      this.resource
        .checkPermission(toCheck)
        .then(results =>
          toCheck.forEach((permission, index) =>
            context.commit('saveChecked', { name: permission, value: results[index] })
          )
        );
    }
  };

  public mutations = {
    // Zapisuje sprawdzone uprawnienie
    saveChecked: (localState: any, checked: { name: string; value: boolean }) =>
      (localState.checked = { ...localState.checked, [checked.name]: checked.value }),
    // Czyści zapisane uprawnienia
    reset: (localState: any) => (localState.checked = {})
  };
}

export default new AccessModule(authResource);
